import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'

const MOCK = [
  {
    day: 'Day 1',
    title: 'Hanoi → Halong Bay · Embarkation',
    content: '<p>Depart Hanoi at noon. Our representative meets you at the lobby for transfer to Tuan Chau Marina (approximately 3.5 hours). Welcome aboard with a refreshing drink and safety briefing. Set sail as lunch is served on deck with panoramic views of the bay. Afternoon activities include kayaking through limestone arches and visiting Sung Sot Cave. Sunset cocktails on the sundeck before a candlelit seafood dinner. Overnight on the bay.</p>',
  },
  {
    day: 'Day 2',
    title: 'Halong Bay · Full Day Exploration',
    content: '<p>Rise early for Tai Chi practice on the upper deck as mist lifts from the karsts. After breakfast, transfer by tender boat to a remote lagoon accessible only by kayak. Visit a traditional pearl farm to learn about cultivation techniques. Return for a cooking class — prepare a classic Vietnamese spring roll with our chef. Afternoon at leisure; optional bamboo boat ride through a mangrove channel. Stargazing on deck after dinner with a marine biologist narrating the constellations.</p>',
  },
  {
    day: 'Day 3',
    title: 'Halong Bay → Hanoi · Disembarkation',
    content: '<p>Sunrise yoga on deck. Enjoy a full breakfast as the crew prepares for check-out. Explore the final scenic stretch of the bay — past towering karst pillars and emerald coves — before disembarking at Tuan Chau Marina at noon. Transfer back to Hanoi, arriving at approximately 4:00 PM. Drop-off at your hotel lobby.</p>',
  },
]

function DayItem({ item, isOpen, onToggle }) {
  return (
    <div className={`si-day-item ${isOpen ? 'si-day-item--open' : ''}`}>
      <button className="si-day-item__header" onClick={onToggle}>
        <span className="si-day-item__label">{item.day}</span>
        <span className="si-day-item__title">{item.title}</span>
        <ChevronDown size={16} className="si-day-item__arrow" strokeWidth={1.5} />
      </button>
      <div className="si-day-item__body">
        <div className="si-prose" dangerouslySetInnerHTML={{ __html: item.content }} />
      </div>
    </div>
  )
}

export default function Days({ days }) {
  const [openIdx, setOpenIdx] = useState(0)
  const list = days?.length ? days : MOCK

  return (
    <section className="si-section">
      <h2 className="ljn-section-title">Day by Day</h2>
      <div className="ljn-divider" style={{ marginBottom: 28 }} />
      <div className="si-days">
        {list.map((item, i) => (
          <DayItem
            key={i}
            item={item}
            isOpen={openIdx === i}
            onToggle={() => setOpenIdx(openIdx === i ? null : i)}
          />
        ))}
      </div>
    </section>
  )
}
